module.exports = "/_next/static/images/Frame2Mobile-dcf0c7803304b6fd52ec0c806a77fd31.png";